<template>
  <div id="cycle-table-container">
    <div class="ct-header">
      Cycle History
    </div>
    <div class="ct-container">
      <v-data-table
        :headers="headers"
        :items="leadCycleData"
        hide-default-footer
      />
    </div>
  </div>
</template>

<script>
import leadDetailMixin from '@shared/mixins/leadDetailMixin';

export default {
  name: 'CycleTable',
  mixins: [leadDetailMixin],
  data() {
    return {
      headers: [{
        text: 'Date',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'date',
      }, {
        text: 'Time',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'time',
      }, {
        text: 'Runtime',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'runtime',
      }, {
        text: 'OA Temp/RH',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'oaTemp',
      }, {
        text: 'Sup/Ret',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'supRet',
      }, {
        text: 'Performance',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'performance',
      }, {
        text: 'Delta P',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'deltaP',
      }],
    };
  },
};
</script>

<style lang="scss">

#cycle-table-container {
  display: flex;
  flex-direction: column;
  .ct-header {
    font-weight: 800;
    color: $N100;
    margin-bottom: 10px;
    font-size: 12pt;
  }
  .ct-container {
    position: relative;
    .v-data-table__wrapper {
      max-height: 400px;
      width: 355pt;
      thead {
        tr {
          th {
            background-color: $N100;
            color: $WHITE;
            font-size: 6pt;
            font-weight: 500;
            height: 30px;
            text-transform: uppercase;
          }
        }
      }
      tbody {
        tr {
          td {
            height: 30px;
            border: 0;
            font-size: 8px;
          }
          &:nth-child(even) {
            background-color: $N5;
          }
        }
      }
    }
  }
}
</style>
